/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const userProductLikesSchema = z.object({
	product_id: z.uuid(),
	likes_count: z.int(),
	liked: z.boolean().optional().default(true),
});
